import React from 'react';
import styles from "./Footer.module.css"
import Icons, {LiaFacebook,FaInstagram,RiTwitterXFill } from "../Icons";
export default function Footer(){
    return(
            <div className={styles.footermain}>
                <div>copyright@spendhatch</div>
                <div><LiaFacebook/></div>
                <div><FaInstagram /></div>
                <div><RiTwitterXFill  /></div>
            </div>
    )
}